export default __webpack_public_path__ + "static/media/AvatarFilipG.f80d21cb.svg";